module.exports = __webpack_public_path__ + "static/dribbble-4db61e653920737fc6150e7f7bf9436c.svg";